export default __webpack_public_path__ + "static/media/nv13.93ddc2a8.PNG";